//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { RegistrationStatus } from './Enums';

export class CreateAttendanceResultItem extends ItemBase {
    EventID: string | null = null;
    AttendanceID: string | null = null;
    Status: RegistrationStatus = RegistrationStatus.Success;

    constructor(initializer?: Partial<CreateAttendanceResultItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "CreateAttendanceResultItem";
}
